import { clearDocument } from 'y-indexeddb';
const DOCUMENT_RESTORED_FLAG_PREFIX = 'nb:document-restored:';
export const getDocumentRestoredFlagKey = (documentId) => {
    return `${DOCUMENT_RESTORED_FLAG_PREFIX}${documentId}`;
};
export const markDocumentRestoredForReload = (documentId) => {
    if (typeof sessionStorage === 'undefined') {
        return;
    }
    sessionStorage.setItem(getDocumentRestoredFlagKey(documentId), '1');
};
export const clearLocalDocumentCacheIfRestored = async (documentId) => {
    if (typeof sessionStorage === 'undefined') {
        return false;
    }
    const flagKey = getDocumentRestoredFlagKey(documentId);
    if (!sessionStorage.getItem(flagKey)) {
        return false;
    }
    sessionStorage.removeItem(flagKey);
    await clearDocument(documentId);
    return true;
};
//# sourceMappingURL=clear-local-document-cache.js.map